import { plural } from '@cian/utils';

interface IFormatGuestsParams {
  adults: number;
  children: number;
}

export function formatGuests(params: IFormatGuestsParams): string {
  const { adults, children } = params;

  return `${formatAdults(adults)}, ${formatChildren(children)}`;
}

function formatAdults(adults: number) {
  return `${adults} ${plural(adults, ['взрослый', 'взрослых', 'взрослых'])}`;
}

function formatChildren(children: number) {
  if (!children) {
    return 'без детей';
  }

  return `${children} ${plural(children, ['ребёнок', 'ребёнка', 'детей'])}`;
}
